function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContentsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 14.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contents-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.54,4.69,15,1a.29.29,0,0,0-.27-.18l-.11,0-2.24.94,1.82,1.42a1.2,1.2,0,0,1,.45.81,1.22,1.22,0,0,1-.12.69Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57,3a1.22,1.22,0,0,1,.65.67,1.2,1.2,0,0,1,0,.93l0,.07h3.2l.29-.37a.29.29,0,0,0,0-.41L8.68.06a.29.29,0,0,0-.41,0L6.89,1.88Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21,3.88,3.45,1.41l-.11,0a.29.29,0,0,0-.27.18L1.73,4.69H9.18l.18-.43a.29.29,0,0,0-.15-.38Z",
    style: {
      fill: "#3fa9f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.79,6.21a.84.84,0,0,0-.64-.29H.84a.84.84,0,0,0-.83,1l1,6.81a.84.84,0,0,0,.83.72H16.17a.84.84,0,0,0,.83-.72l1-6.81A.84.84,0,0,0,17.79,6.21Z",
    style: {
      fill: "#3fa9f5"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentsActive);
export default __webpack_public_path__ + "static/media/icon-contents-active.9f0cb3aab34217c4f16813c05a6e4cff.svg";
export { ForwardRef as ReactComponent };